(function() {
  // Prevent double loading logic
  if (window.CardV2Loaded) return;
  window.CardV2Loaded = true;

  // --- 1. Init Swipers Function ---
  window.initCardV2 = function(scope = document) {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper JS not loaded yet. Waiting...');
      setTimeout(() => window.initCardV2(scope), 200);
      return;
    }

    const swipers = scope.querySelectorAll('.product-card-swiper');
    
    swipers.forEach(el => {
      if(el.classList.contains('swiper-initialized')) return; 

      // Get the initial slide index from the data attribute
      const startSlide = parseInt(el.getAttribute('data-initial-slide')) || 0;

      const swiper = new Swiper(el, {
        slidesPerView: 1,
        initialSlide: startSlide, // Start on the metafield-defined variant
        effect: 'fade', 
        fadeEffect: { crossFade: true },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
        on: {
          slideChange: function () {
            const activeIndex = this.activeIndex;
            const activeSlide = this.slides[activeIndex];
            const colorValue = activeSlide.dataset.colorValue;
            const card = el.closest('.product-card-v2');

            if (colorValue && card) {
              const radio = card.querySelector(`input[type="radio"][value="${CSS.escape(colorValue)}"]`);
              if (radio) {
                radio.checked = true;
                const label = radio.closest('.product-card-swatch');
                card.querySelectorAll('.product-card-swatch').forEach(s => s.classList.remove('is-active'));
                if(label) label.classList.add('is-active');
              }
            }
          }
        }
      });
    });
  };

  // --- 2. Swatch Click Listener (Delegated) ---
  document.addEventListener('change', function(e) {
    if(e.target.name && e.target.name.startsWith('color-')) {
      const swatch = e.target.closest('.product-card-swatch');
      if (!swatch) return;
      
      const container = swatch.closest('.product-card-v2');
      if(!container) return;

      const colorValue = swatch.dataset.colorValue;
      
      // Update Visuals
      container.querySelectorAll('.product-card-swatch').forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');

      // Update Slider
      if (colorValue) {
        const swiperContainer = container.querySelector('.swiper');
        if (swiperContainer && swiperContainer.swiper) {
          const slides = Array.from(swiperContainer.querySelectorAll('.swiper-slide'));
          const targetIndex = slides.findIndex(slide => slide.dataset.colorValue === colorValue);
          
          if (targetIndex >= 0) {
            swiperContainer.swiper.slideTo(targetIndex);
          }
        }
      }
    }
  });

  // Initialize on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', () => {
    window.initCardV2();
  });

})();